module.exports = __webpack_public_path__ + "static/media/logo.2dc51750.png";